export const recordOfDetentionTemplateIds = ["mha-h3"];
export const applicationTemplateIds = [
    "mha-a1",
    "mha-a2",
    "mha-a5",
    "mha-a6",
    "mha-a9",
    "mha-a10",
];
export const jointMedicalRecordsTemplateIds = ["mha-a3", "mha-a7"];
export const singleMedicalRecordsTemplateIds = ["mha-a4", "mha-a8", "mha-a11"];
export const medicalRecommendationTemplateIds = [
    ...jointMedicalRecordsTemplateIds,
    ...singleMedicalRecordsTemplateIds,
];
export const section4Templates = ["mha-a9", "mha-a10"];
export const nonThalamosFormTemplateIds = ["mha-a1", "mha-a5", "mha-a9"];
export const admissionTemplateIds = [
    ...applicationTemplateIds,
    ...medicalRecommendationTemplateIds,
];
export const FDMCA_TEMPLATE_ID = "mca-fdmca";
export const BID_TEMPLATE_ID = "mca-bid";
// The Mental Capacity Act forms that may be completed together as one combined
// assessment, and so share a single "mca-assessment" form context. Adding a
// template here brings it into the shared-context naming and prompting rules.
export const mcaTemplateIds = [FDMCA_TEMPLATE_ID, BID_TEMPLATE_ID];
// Forms eligible for de minimis corrections (file-note-based minor corrections).
// Excludes: admission forms (covered by S15 amends), SOAD, 136, and ACD forms.
export const deMinimisEligibleTemplateIds = [
    // Hospital forms
    "mha-h1",
    "mha-h2",
    "mha-h3",
    "mha-h4",
    "mha-h5",
    "mha-h6",
    // CTO forms
    "mha-cto1",
    "mha-cto2",
    "mha-cto3",
    "mha-cto4",
    "mha-cto5",
    "mha-cto6",
    "mha-cto7",
    "mha-cto8",
    "mha-cto9",
    "mha-cto10",
    "mha-cto12",
    // Treatment forms
    "mha-s62",
    "mha-t2",
    "mha-t4",
    // Discharge forms
    "mha-s23",
    "mha-hpd",
    // Miscellaneous forms
    "mha-m1",
    "mha-m2",
];
//# sourceMappingURL=sections.js.map